export enum ActionTypes {
  LOAD_COSTS_REQUEST = 'LOAD_COSTS_REQUEST',
  LOAD_COSTS_SUCCEEDED = 'LOAD_COSTS_SUCCEEDED',
  LOAD_COSTS_FAILED = 'LOAD_COSTS_FAILED',

  LOAD_DRIVERS_NAME_SUCCEEDED = 'LOAD_DRIVERS_NAME_SUCCEEDED',

  DOWNLOAD_COSTS_REQUEST = 'DOWNLOAD_COSTS_REQUEST',
  DOWNLOAD_COSTS_END = 'DOWNLOAD_COSTS_END',
}
